import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { etiquetasEtapas } from "../etapas";

// onSaved: lo manda el listado para refrescarse sin recargar la página
function OportunidadesCreate({ prospectoFijo, onSaved }) {
  const { user } = useContext(AuthContext);
  const URL_CRM_OPORTUNIDADES = process.env.REACT_APP_URL_CRM_OPORTUNIDADES;
  const URL_CRM_PROSPECTOS = process.env.REACT_APP_URL_CRM_PROSPECTOS;
  const URL_CRM_ETAPAS = process.env.REACT_APP_URL_CRM_ETAPAS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  const [prospectos, setProspectos] = useState([]);
  const [etapas, setEtapas] = useState([]);
  const etiquetaEtapa = etiquetasEtapas(etapas);
  const [usuarios, setUsuarios] = useState([]);

  const [prospecto, setProspecto] = useState(prospectoFijo || "");
  const [titulo, setTitulo] = useState("");
  const [etapa, setEtapa] = useState("");
  const [valor_estimado, setValorEstimado] = useState(0);
  const [fecha_estimada_cierre, setFechaCierre] = useState("");
  const [producto_interes, setProductoInteres] = useState("");
  const [responsable, setResponsable] = useState("");
  const [proxima_accion, setProximaAccion] = useState("");
  const [fecha_proxima_accion, setFechaProximaAccion] = useState("");
  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    const headers = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };
    axios.get(URL_CRM_PROSPECTOS, headers).then((r) => setProspectos(r.data)).catch((e) => console.log(e));
    axios
      .get(URL_CRM_ETAPAS, headers)
      .then((r) => {
        setEtapas(r.data);
        // Preselecciona la primera etapa abierta del pipeline.
        const primera = r.data.find((et) => et.tipo === "abierta");
        if (primera) setEtapa(primera._id);
      })
      .catch((e) => console.log(e));
    axios.get(URL_COLABORADORES, headers).then((r) => setUsuarios(r.data)).catch((e) => console.log(e));
  }, []);

  const saveOportunidad = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    const hoy = new Date().toISOString().split("T")[0];
    const body = {
      prospecto,
      titulo,
      etapa,
      valor_estimado: Number(valor_estimado),
      fecha_estimada_cierre,
      producto_interes,
      proxima_accion,
      fecha_proxima_accion,
      fecha_ultima_actividad: hoy,
      usuarioNombre: user.nombre,
    };
    if (responsable) body.responsable = responsable;
    axios
      .post(URL_CRM_OPORTUNIDADES, body, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then(() => {
        axios.post(
          URL_LOGS,
          { tipo: "Crear Oportunidad", detalle: titulo, user: user.id },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
        Swal.fire("Good job!", "Oportunidad creada con exito", "success");
        if (onSaved) onSaved();
        else setTimeout(() => window.location.reload(), 1000);
      })
      .catch((error) => {
        setValidaBoton(true);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response ? error.response.data : error}`,
        });
      });
  };

  return (
    <Form onSubmit={saveOportunidad}>
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label>Prospecto *</Label>
            <Input
              type="select"
              value={prospecto}
              required
              disabled={!!prospectoFijo}
              onChange={(e) => setProspecto(e.target.value)}
            >
              <option value="">Selecciona...</option>
              {prospectos.map((p) => (
                <option key={p._id} value={p._id}>
                  {p.razon_social} {p.empresa ? `- ${p.empresa}` : ""}
                </option>
              ))}
            </Input>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>Producto *</Label>
            <Input
              type="text"
              placeholder="Ej. Uniformes 2027 (filipinas y pantalones)"
              value={titulo}
              required
              onChange={(e) => setTitulo(e.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup>
            <Label>Etapa</Label>
            <Input type="select" value={etapa} onChange={(e) => setEtapa(e.target.value)}>
              <option value="">Selecciona...</option>
              {etapas
                .sort((a, b) => (a.orden > b.orden ? 1 : -1))
                .map((et) => (
                  <option key={et._id} value={et._id}>
                    {etiquetaEtapa[et._id]}
                  </option>
                ))}
            </Input>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>Valor estimado ($)</Label>
            <Input
              type="number"
              value={valor_estimado}
              onChange={(e) => setValorEstimado(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>Fecha estimada de cierre</Label>
            <Input
              type="date"
              value={fecha_estimada_cierre}
              onChange={(e) => setFechaCierre(e.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label>Producto de interes</Label>
            <Input
              type="text"
              value={producto_interes}
              onChange={(e) => setProductoInteres(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>Responsable (vendedor)</Label>
            <Input type="select" value={responsable} onChange={(e) => setResponsable(e.target.value)}>
              <option value="">Sin asignar</option>
              {usuarios.map((u) => (
                <option key={u._id} value={u._id}>
                  {u.nombre} {u.apellido}
                </option>
              ))}
            </Input>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label>Proxima accion</Label>
            <Input
              type="text"
              placeholder="Ej. Enviar cotizacion"
              value={proxima_accion}
              onChange={(e) => setProximaAccion(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>Fecha proxima accion</Label>
            <Input
              type="date"
              value={fecha_proxima_accion}
              onChange={(e) => setFechaProximaAccion(e.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row className="container">
        <Button type="submit" className="btn btn-success" disabled={!validaBoton}>
          Guardar
        </Button>
      </Row>
    </Form>
  );
}

export default OportunidadesCreate;
